<template>
        <div class="container" >
                <div class="d-flex justify-content-between align-items-center">
                        <h3>{{ $store.getters['EventStore/eventInfo'].name }} </h3>
                        <b-dropdown text="Ações" variant="primary" right>
                                <b-dropdown-item to="cupoms"> Cupoms de desconto </b-dropdown-item>
                                <b-dropdown-item-button @click="downloadCSV"> Download equipes em tabela </b-dropdown-item-button>
                                <b-dropdown-item-button @click="downloadMemberCSV"> Download membros em tabela </b-dropdown-item-button>
                                <b-dropdown-item to="email"> Enviar emails </b-dropdown-item>
                                <b-dropdown-item :to="'/admin/events/'+$route.params.eventid+'/results'"> 🏅 Resultados &amp; Certificados </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item :to="'/admin/events/'+$route.params.eventid+'/validar-tracklog'"> 📍 Validar Tracklog </b-dropdown-item>
                                <b-dropdown-item :to="'/admin/events/'+$route.params.eventid+'/gpx-config'"> ⚙ Configurar GPX (percursos + janela) </b-dropdown-item>
                        </b-dropdown>
                </div>
                <h1>Admin/Inscrições  <small class='gray'> {{purshaseProducts.length}} Inscrições</small> </h1>
                
                <div class="row">
                        <div class="col-6">
                                 <!-- <pre> {{ paymentfilter }} </pre> -->
                                  <b-form-group class='f6' label="Filtros:">
                                        <b-form-checkbox-group id="checkbox-group-2" v-model="paymentfilter" >
                                                <b-form-checkbox value="payed">Pagos</b-form-checkbox>
                                                <b-form-checkbox value="waiting">Aguardando Pagamento</b-form-checkbox>
                                                <b-form-checkbox value="canceled">Cancelados</b-form-checkbox>
                   


                                        <b-dropdown size="sm" text="Categoria" class="m-2">
                                                <b-dropdown-item-button v-for="cat in allCategorie" @click="addCategoryToFilter(cat.value)" :class='{active:categoryfilter.includes(cat.value)}'>{{ cat.text }} </b-dropdown-item-button>
                                        </b-dropdown>

                                </b-form-checkbox-group>
                                </b-form-group>

                        </div>
                        
                        <div class="col-2 tr">
                                <div class='col-form-label f6'> Visualizar como:</div>
                                <span><ico @click="displayAs='card'" icon="th-list"></ico> </span> &ensp;
                                <span><ico @click="displayAs='table'" icon="table"></ico> </span>
                        </div>

                </div>
                <div class="row" v-if="purshaseProducts.length > 0 ">

                        <div class="col-8">
                                
                                <!-- <input type="search" /> -->
                               
                                <div v-if="displayAs=='card'">
                                        <admin-purshase-product v-for="(product,index) in purshaseProducts" 
                                                                        :purshaseProduct="product" 
                                                                        :index="index+1" 
                                                                        :key="'pp'+product.id" 
                                                                        v-to="`registrations/${product.id}`" 
                                                                        >
                                        </admin-purshase-product>
                                </div>
                                <div v-else>
                                        <table class='table trable-condensed table-striped list-inscricoes'>
                                                <tbody>
                                                        <tr v-for="(pp,index) in purshaseProducts"  :class="pp._paymentStatus">
                                                       
                                                                <td  > 
                                                                <a :href="'registrations/'+pp.id">
                                                                 <ico class='pointer dim' icon="edit"></ico> <br />
                                                                 </a>
                                                                 </td>

                                                                <td> <h5> {{ pp._teamname }} <small>  ({{ pp.id }})   </small> </h5> 
                                                                        <small> {{ pp.name.replace(/^.*?\/\s?/,'') }} <br/>
                                                                        valor: {{ pp.price }} <br/> 
                                                                        status de pagamento: {{pp._paymentStatus}}
                                                                        </small>
                                                                 </td>
                                                                <td> <b>{{ $get(pp,'client.name') }}</b> <br />
                                                                 <small> cpf: {{ $get(pp,'client.cpf') }} <br/>
                                                                 email: {{ $get(pp,'client.email') }} <br/>
                                                                 telefone: {{ $get(pp,'client.telephone') }} 
                                                                 </small>
                                                                 </td>
                                                                <td> {{ $get(pp,'client._paymentStatus') }} </td>
                                                                <td> {{ $get(pp,'client.price') }} </td>
                                                                <td> {{ $get(pp,'order.cupom.code') }} </td>
                                                                
                                                        </tr>
                                                </tbody>
                                        </table>
                                </div>
                        </div>

                        <div class="col-4">
                                <div class="row">
                                <div class="col-12">
                                        <h5>Equipes: {{purshaseProducts.length}}</h5>
                                        <h5>Atletas: {{totalMembers}} </h5>
                                        <hr/>
                                        <h6>Status de pagamento das equipes: </h6>
                                        <dl class="row gray">
                                                <template v-for="(v,k) in totalStatus">
                                                        <dt class="col-sm-4"> {{k}}:</dt>
                                                        <dd class="col-sm-8">{{v}}</dd>
                                                </template>
                                                <!-- <dt class="col-sm-4"> <b>total:</b></dt>
                                                <dd class="col-sm-8"><b>{{purshaseProducts.length}}</b></dd> -->
                                        </dl>
                                </div>
                                <div class="col-12 mt-1">
                                        <hr/>
                                        <h6>Total de Camisetas: </h6>
                                        <dl class="row gray">
                                                <template v-for="(v,k) in totalShirtSizes">
                                                        <dt class="col-sm-4"> {{k}}:</dt>
                                                        <dd class="col-sm-8">{{v}}</dd>
                                                </template>
                                                <!-- <dt class="col-sm-4"> <b>total atletas:</b></dt>
                                                <dd class="col-sm-8"><b>{{totalMembers}}</b></dd> -->
                                        </dl>
                                </div>
                                <div class="col-12 mt-1">
                                        <hr/>
                                        <h6>Total por Categoria: </h6>
                                                <template v-for="(v,k) in totalCategorie">
                                        <dl class="row gray">
                                                        <dd class="col-sm-2">{{v}}</dd>
                                                        <dt class="col-sm-10"> {{k}}</dt>
                                                <!-- <dt class="col-sm-4"> <b>total atletas:</b></dt>
                                                <dd class="col-sm-8"><b>{{totalMembers}}</b></dd> -->
                                        </dl>
                                                        <hr /> 
                                                </template>
                                </div>
                                <!-- <pre>{{totalShirtSizes}}</pre>
                                <pre>{{totalStatus}}</pre> -->

                </div>

                        </div>
                </div>



                <div v-else>
                        
                </div>

               

                
            
        </div>
</template>


<script>
import api from '@/api';

export default {
        data(){
                return {
                        status:false,
                        paymentfilter:['payed'],
                        categoryfilter:[],
                        displayAs:'table',
                        downloadMember:true,
                }
        },

        created:function(){
                this.$store.dispatch('PurchaseStore/loadEventRegistrations', this.$route.params.eventid)
                this.$store.dispatch('EventStore/loadEvent', this.$route.params.eventid)
        },
        computed:{
                id:function(){
                        return this.$route.params.id
                },

                purshaseProducts:function(){
                        let pp = this.$store.getters['PurchaseStore/myRegistrations']

                        
                        if( this.paymentfilter.includes('payed') ){
                                 pp = _.filter(pp, p=>{
                                     return this.paymentfilter.includes(p.paymentStatus) || p.payedByAdmin === true 
                                })
                        }else{
                                pp = _.filter(pp, p=>{
                                     return this.paymentfilter.includes(p.paymentStatus) && p.payedByAdmin != true 
                                })
                        
                        }
                        
                        if(! _.isEmpty(this.categoryfilter)){
                                pp = _.filter(pp, p=>{
                                        return this.categoryfilter.includes(p.product.id)
                                })
                        }

                        


                        return pp
                },

                totalShirtSizes: function(){
                        let camiseta = [];
                        _.each(this.purshaseProducts, pp=>{
                                _.each(pp.members, member=>{
                                        let v = _.get(member,'infos.camiseta')
                                        if(v=='') v='?';
                                        camiseta.push(v)
                                })
                        })

                        return _.countBy(camiseta);

                },
                totalCategorie: function(){
                        let categorie = [];
                        _.each(this.purshaseProducts, pp=>{
                               
                                        categorie.push( pp.name.replace(/^[^\/]*?\//,'') )
                        })

                        return _.countBy(categorie);

                },

                allCategorie: function(){
                        let categorie = [ {value:'', text:' -- nenhum --' } ];
                        let catInclud = [];
                        _.each(this.$store.getters['PurchaseStore/myRegistrations'], pp=>{
                                        if( ! catInclud.includes(pp.product.id)){
                                                categorie.push( {  value:pp.product.id, text:pp.name.replace(/^[^\/]*?\//,'')} )
                                                catInclud.push(pp.product.id)
                                        }
                        })

                        return _.sortBy(categorie,'text');

                },

                totalMembers: function(){
                        let total = 0;
                        _.each(this.purshaseProducts, pp=>{
                                _.each(pp.members, member=>{
                                       total++
                                })
                        })

                        return total;

                },

                totalStatus:function(){
                        let status = [];
                        _.each(this.purshaseProducts, pp=>{
                               
                                        status.push(pp._paymentStatus)
                                
                        })

                        return _.countBy(status);

                },
        },

        methods: {

                addCategoryToFilter:function(id){
                        if(id==''){
                                 this.categoryfilter = []
                        } else if( this.categoryfilter.includes(id)){
                                this.categoryfilter = _.filter(this.categoryfilter,v=>v!==id)
                        }else{
                                this.categoryfilter = [id]
                        }
                },

                downloadCSV:function(){


                        var rows = [["Nº", "Data de Inscrição", "Equipe", "CPF do comprador", "Nome comprador",  "Email",  "Telefone", "Status de Pagamento", "Preço", "Categoria","CUPOM DE DESCONTO"]];
                        
                        _.each(this.purshaseProducts,(pp,index)=>{
                                let teamName =  _.get(pp,'_teamname','');
                                let bueyrName =  _.get(pp,'client.name','');
                                let bueyrCpf =  _.get(pp,'client.cpf','');
                                bueyrCpf = bueyrCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"\$1.\$2.\$3\-\$4");
                                let bueyrEmail =  _.get(pp,'client.email','');
                                let bueyrTel =  _.get(pp,'client.telephone','');
                                let paymentStatus =  _.get(pp,'_paymentStatus','');
                                let dataCadastro =  _.get(pp,'created','2022-01-01');
                                if(dataCadastro) dataCadastro = new Date(dataCadastro).toLocaleDateString('pt-br')
                                let categoria = _.get(pp,'name','').replace(/^.*?\/\s?/,'')
                                let cupom = _.get(pp,'order.cupom.code','')
                                rows.push([pp.id, dataCadastro, teamName, bueyrCpf, bueyrName, bueyrEmail, bueyrTel, paymentStatus, _.get(pp,'price'), categoria, cupom  ])
                                
                             
                        })
                        let filename = 'listaInscritos-'+new Date().toLocaleDateString('pt-br')+".csv"
                        window._util.downloadCSV(rows, filename);
                },


                downloadMemberCSV:function(){

                        // var rows = [["Nº", "Data de Inscrição", "Equipe", "CPF do comprador", "Nome comprador",  "Email",  "Telefone", "Status de Pagamento", "Preço", "Categoria"]];
                        var cols = ["Nº","Equipe"]

                        let colsMembers = []
                        let teamCols = []
                         _.each(this.purshaseProducts,(pp,index)=>{
                                let members = this.$store.getters['PurchaseStore/membersForPurshaseProduct'](pp.id);

                                _.each(members[0].infos, (v,k)=>{
                                        if(!colsMembers.includes(k)){
                                                colsMembers.push(k)
                                        }
                                })
                                 _.each(_.get(pp,'team[0].infos'), (v,k)=>{
                                        if(!teamCols.includes(k)){
                                                teamCols.push(k)
                                        }
                                })
                                
                         })
                        cols = cols.concat(teamCols, colsMembers,["Categoria"])
                        var rows = [cols]

                        _.each(this.purshaseProducts,(pp,index)=>{
                                
                                let teamName =  _.get(pp,'_teamname','')
                                let bueyrName =  _.get(pp,'client.name','');
                                let bueyrCpf =  _.get(pp,'client.cpf','');
                                bueyrCpf = bueyrCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"\$1.\$2.\$3\-\$4");
                                let bueyrEmail =  _.get(pp,'client.email','');
                                let bueyrTel =  _.get(pp,'client.telephone','');
                                let paymentStatus =  _.get(pp,'_paymentStatus','');
                                let dataCadastro =  _.get(pp,'created','2022-01-01');
                                if(dataCadastro) dataCadastro = new Date(dataCadastro).toLocaleDateString('pt-br')
                                let categoria = _.get(pp,'name','').replace(/^.*?\/\s?/,'')
                               
                        
                                let members = this.$store.getters['PurchaseStore/membersForPurshaseProduct'](pp.id);
                               
                                rows.push([paymentStatus])
                                _.each(members, (member,index)=>{
                                        let info = ""
                                        let cols = [pp.id, teamName]
                                        
                                        _.each(teamCols, (colName)=>{
                                                cols.push( _.get(pp.team[0].infos,colName,'')) 
                                        })
                                        _.each(colsMembers, (colName)=>{
                                                cols.push( _.get(member.infos,colName,'')) 
                                        })
                                        // _.each(member.infos, (v,k)=>{
                                        
                                        //                 cols.push(v) 
                                        // })

                                        cols.push(categoria) 
                                        
                                        rows.push( cols )     
                                })

                                 rows.push( [] )    
                                 rows.push( [] )    
                                
                        })
                        let filename = 'listaMembrosInscritos-'+new Date().toLocaleDateString('pt-br')+".csv"
                        window._util.downloadCSV(rows, filename);
                },
        }

}
</script>

<style lang="stylus">
        .list-inscricoes{
                tr.payed{
                        border-left: 4px solid green;
                }
                tr.waiting{
                        border-left: 4px solid yellow;
                }
                tr.canceled{
                        border-left: 4px solid red;
                }
        }
</style>
